export default {
  meEndpoint: '/auth/me',
  loginEndpoint: '/jwt/login',
  registerEndpoint: '/jwt/register',
  storageTokenKeyName: 'accessToken',
  refreshToken: 'refreshToken',
  azureRefreshToken: 'azureRefreshToken'
}
